const state = () => ({
	taskItem: null,
})

const getters = {
	getTaskItem: state => state.taskItem,
}

const mutations = {
	setTaskItem: (state, payload) => {
        state.taskItem = payload;
    },
}

export default {
	namespaced: true,
	state,
	getters,
	mutations
}